<app-public-page-template [headerText]="headerText"
                          [logoOverrideSrc]="logoOverrideSrc">
    <div class="text-center">
        @if (viewState === 'LOADING') {
            <p>Hang tight while we confirm your verification link.</p>
        }

        @if (viewState === 'VERIFIED') {
            <p>Your email has been verified and your account is ready to use.</p><p>To log in, use your email and the
                password you set when signing up.</p>
            <div class="action-button-group">
                <button (click)="goToLogin()" class="navy-btn" type="button">Go to Login</button>
            </div>
        }

        @if (viewState === 'EXPIRED') {
            <p>Verification links are valid for 24 hours. Start the signup again to get a fresh link.</p>
            <div class="action-button-group">
                <button (click)="restartSignup()" class="navy-btn" type="button">Start Signup Again</button>
            </div>
        }

        @if (viewState === 'INVALID') {
            <p>If you've already verified your email, go ahead and log in. Otherwise, contact support for help.</p>
            <div class="action-button-group">
                <button (click)="goToLogin()" class="navy-btn" type="button">Go to Login</button>
            </div>
        }

        @if (viewState === 'MISSING_TOKEN') {
            <p>Open the link from the email we sent you when you signed up to verify your email.</p>
        }

        @if (viewState === 'ERROR') {
            <p>We couldn't verify your email. Try the link again, or contact support if the problem persists.</p>
        }
    </div>
</app-public-page-template>
